import React, { useEffect, useState, useRef } from 'react';
import PageTitle from '../../../widgets/PageTitle/PageTitle';
import './YDCCollection.scss';
import { Card, CardImg } from 'reactstrap';
import VideoPlayer from '../../../components/VideoPlayer/VideoPlayer';
import { parseSanitizedHTML } from '../../../utils/Helper';
import PreviewImageAndClick from '../../../widgets/PreviewImageAndClick/PreviewImageAndClick';

const YDCCollection = (props) => {
  const { curLang, collectionPhotos, collectionDescriptions, title } = props;

  const [previewImgOpen, setPreviewImgOpen] = useState(false);
  const [selectImgIndex, setSelectImgIndex] = useState(0);
  const previewImgToggle = () => setPreviewImgOpen(!previewImgOpen);
  const selectImgIndexFun = (index) => setSelectImgIndex(index);

  return (
    <>
      <PageTitle title={title} />
      <div className="ydc-collection">
        <div className="collections-card-grid">
          {collectionPhotos &&
            collectionPhotos.map((item, index) => (
              <React.Fragment key={`group_${index}`}>
                {(item.collection_images_upload || item.collection_video) && (
                  <Card key={`img_${index}`} className="collections-card">
                    {item.collection_video ? (
                      <div className="video-container">
                        <div
                          className="mask-wrapper"
                          onClick={() => {
                            selectImgIndexFun(index);
                            setPreviewImgOpen(true);
                          }}
                        ></div>
                        <VideoPlayer src={item.collection_video} loop is16than9={false} />
                      </div>
                    ) : (
                      <div
                        className="photo-container"
                        onClick={() => {
                          selectImgIndexFun(index);
                          setPreviewImgOpen(true);
                        }}
                      >
                        <CardImg
                          src={item.collection_images_upload}
                          alt={`collection-image-${index}`}
                        />
                        {!collectionDescriptions?.[index]?.collection_description &&
                          collectionDescriptions?.[index]?.collection_finalist_name && (
                            <div class="itemCaption">
                              {collectionDescriptions[index].collection_finalist_name}
                            </div>
                          )}
                      </div>
                    )}
                  </Card>
                )}
                {collectionDescriptions?.[index]?.collection_description && (
                  <Card key={`text_${index}`} className="collections-card">
                    <div className="description-container">
                      <div className="finalist">Finalist</div>
                      <div className="conllection-name">
                        {collectionDescriptions[index]
                          ? collectionDescriptions[index].collection_name
                          : ''}
                      </div>
                      <div className="conllection-finalist-name">
                        <span>
                          {collectionDescriptions[index]
                            ? collectionDescriptions[index].collection_finalist_name
                            : ''}
                        </span>
                        <a
                          className="fa-instagram"
                          target="_blank"
                          href={item.collection_instagram}
                        ></a>
                      </div>
                      <div className="conllection-description">
                        {collectionDescriptions[index]
                          ? parseSanitizedHTML(collectionDescriptions[index].collection_description)
                          : ''}
                      </div>
                    </div>
                  </Card>
                )}
              </React.Fragment>
            ))}
        </div>
      </div>
      <PreviewImageAndClick
        previewImgToggle={previewImgToggle}
        previewImgOpen={previewImgOpen}
        selectImgIndex={selectImgIndex}
        selectImgIndexFun={selectImgIndexFun}
        imageList={collectionPhotos.map((item, index) => ({
          image: item.collection_images_upload,
          video: item.collection_video,
        }))}
        needCount={true}
      />
    </>
  );
};

export default YDCCollection;
